import { useEffect } from 'react';
import { useStores } from 'stores/index';
import { observer } from 'mobx-react';

//@ts-ignore
import { Card, Form, FormItem, InputPassword, useForm, Button, notify } from '@microui/react-ui';

const Main = () => {
    const { userStore } = useStores();
    const [form] = useForm();

    useEffect(() => {
        if (form) {
            form.setFieldsValue({
                OldPassword: '',
                NewPassword: '',
                ConfirmPassword: '',
            });
        }
    }, []);

    const handleSubmit = (data) => {
        userStore.changePassword(data)
            .then(() => {
                form.resetFields();
                notify.success('Đổi mật khẩu thành công');
            });
    };

    return (
        <div className="p-6 flex flex-col items-center">
            <Card
                head={
                    <div className='w-full text-center text-headline-4 text-primary-400 font-medium'>
                        Thay đổi mật khẩu
                    </div>
                }
                className={'max-w-[800px]'}
            >
                <div className="p-6">
                    <Form
                        form={form}
                        onFinish={handleSubmit}
                    >
                        <FormItem
                            label='Mật khẩu cũ'
                            name="OldPassword"
                            required
                            rules={['password']}
                        >
                            <InputPassword disabled={userStore.loading} />
                        </FormItem>

                        <FormItem
                            label='Mật khẩu mới'
                            name="NewPassword"
                            required
                            rules={[
                                'password'
                            ]}
                        >
                            <InputPassword disabled={userStore.loading} />
                        </FormItem>

                        <FormItem
                            label='Nhập lại mật khẩu mới'
                            name="ConfirmPassword"
                            required
                            rules={[
                                {
                                    validator: (rule, value, callback) => {
                                        if (value !== form.getFieldValue('NewPassword')) {
                                            callback("Mật khẩu mới phải trùng khớp")
                                        }
                                        callback();
                                    }
                                },
                                'password'
                            ]}
                        >
                            <InputPassword disabled={userStore.loading} />
                        </FormItem>
                    </Form>

                    <div className="flex w-full items-center justify-center pt-5">
                        <Button loading={userStore.loading} onClick={form.submit} type='primary' color='primary'>Lưu thay đổi</Button>
                    </div>
                </div>
            </Card>
        </div>
    );
}

export default observer(Main);